require('./mortgageRequestPreApprovalStepTwo.scss');
//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const { FormattedText, formatText } = require('core/i18n').i18n;
//@helpers
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
//@components
const MortgageRequestIframeAFI = require('components/mortgageRequest/mortgageRequestIframeAFI/mortgageRequestIframeAFI');
const { CollectiveTag } = require('components/commons/collectiveTag/collectiveTag');
const MortgagesCollectiveTagTooltip = require('components/mortgagesCollectiveTagTooltip/mortgagesCollectiveTagTooltip');
//@constants
const { MORTGAGE_COLLECTIVE_PRODUCT_ALIAS, MORTGAGE_MINIMUM_YEARS_AFI_OPTIONS } = require('constants/mortgageRequestPreApproval').mortgageRequestPreApprovalCommons;

class MortgageRequestPreApprovalStepTwo extends React.Component {

    buildHeader() {
        const { immMortgageRequest, immGlobalVariables } = this.props;
        const totalYears = immMortgageRequest.get('timeMoneyReturn');
        const totalAmount = immMortgageRequest.get('moneyNeed');
        const amount = MortgageRequestCurrencyHelp({ currency: totalAmount, withDecimals: false });
        const optionTwo = formatText('mortgageRequestPreApprovalStepTwo-mortgageRequestPreApprovalStepTwo_twoOptions');
        const optionThree = formatText('mortgageRequestPreApprovalStepTwo-mortgageRequestPreApprovalStepTwo_threeOptions');
        const optionAFI = totalYears <= MORTGAGE_MINIMUM_YEARS_AFI_OPTIONS ? optionTwo : optionThree;
        const defaultEuribor = immGlobalVariables.getIn(['variables', 'parameters', 'hipoteca', 'default_euribor']);
        const defaultTae = immGlobalVariables.getIn(['variables', 'parameters', 'hipoteca', 'default_tae_variable']);

        const taxes = {
            euribor: defaultEuribor,
            tae: defaultTae
        };
        const tooltipContent = <MortgagesCollectiveTagTooltip taxes={taxes} />;

        return (
            <header className="mortgage-request-preapproval-step-two__header">
                <div className="row">
                    <div className="col-md-12">
                        <h2 className="mortgage-request-preapproval-step-two__header-title">
                            <FormattedText
                                value="mortgageRequestPreApprovalStepTwo-mortgageRequestPreApprovalStepTwo_title"
                            />
                            <CollectiveTag
                                extraClass={"calculate-quota__collective-tag"}
                                productAlias={MORTGAGE_COLLECTIVE_PRODUCT_ALIAS}
                                tooltipContent={tooltipContent}
                            />
                        </h2>
                        <h3 className="mortgage-request-preapproval-step-two__header-subtitle">
                            <FormattedText
                                injectedStrings={[optionAFI, amount, totalYears]}
                                value="mortgageRequestPreApprovalStepTwo-mortgageRequestPreApprovalStepTwo_subTitle"
                            />
                        </h3>
                    </div>
                </div>
            </header>
        );
    }

    render() {
        const headerSection = this.buildHeader();
        const { immMortgageRequest, immCollectives, validateStep, preApprovalLoadAFI, preApprovalLoadAFIFinish, flagBasedFeatures, preApprovalUUID, mortgageHomeInsurance, getInsurancesDataAfi, productTypeInf, onHandleGetCatalogInformation } = this.props;
        return (
            <section className="mortgage-request-preapproval-step-two">
                {headerSection}
                <div>
                    <MortgageRequestIframeAFI
                        immMortgageRequest={immMortgageRequest}
                        flagBasedFeatures={flagBasedFeatures}
                        validateStep={validateStep}
                        preApprovalLoadAFI={preApprovalLoadAFI}
                        preApprovalLoadAFIFinish={preApprovalLoadAFIFinish}
                        preApprovalUUID={preApprovalUUID}
                        immCollectives={immCollectives}
                        getInsurancesDataAfi={getInsurancesDataAfi}
                        mortgageHomeInsurance={mortgageHomeInsurance}
                        productTypeInf={productTypeInf}
                        getCatalogInformation={onHandleGetCatalogInformation}
                    />
                </div>
            </section >
        );
    }
}
MortgageRequestPreApprovalStepTwo.propTypes = {
    immMortgageRequest: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    validateStep: PropTypes.func.isRequired,
    preApprovalLoadAFI: PropTypes.func.isRequired,
    preApprovalLoadAFIFinish: PropTypes.func.isRequired,
    preApprovalUUID: PropTypes.func.isRequired,
    flagBasedFeatures:PropTypes.object.isRequired,
    immCollectives: PropTypes.object.isRequired,
    getInsurancesDataAfi: PropTypes.func.isRequired,
    mortgageHomeInsurance: PropTypes.func.isRequired,
    productTypeInf: PropTypes.func.isRequired,
    onHandleGetCatalogInformation: PropTypes.func.isRequired
};
module.exports = MortgageRequestPreApprovalStepTwo;
